import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
// import { apiMktf } from '../environment/environment';
import {environment} from "../../environments/environment";

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<any>;
    public currentUser: Observable<any>;
    private currentRoleSubject: BehaviorSubject<any>;
    public currentRole: Observable<any>;

    backendUrl: string = environment.apiUrl;
    url_final: string;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
        this.currentRoleSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('currentRole')));
        this.currentRole = this.currentRoleSubject.asObservable();
    }

    public get currentUserValue() {
        return this.currentUserSubject.value;
    }
    public get currentRoleValue() {
        return this.currentRoleSubject.value;
    }

    login(username, password,tienda) {
      this.url_final = this.backendUrl + "/loginfe"
        return this.http.post<any>(this.url_final, { username, password,tienda })
            .pipe(map(user => {
                if(user.result == 200){
                  // store user details and jwt token in local storage to keep user logged in between page refreshes
                  localStorage.setItem('currentUser', JSON.stringify(user));
                  this.currentUserSubject.next(user);
                  // console.log("la respuesta es")
                  // console.log(user.result);

                  if(user["role"] == "admin"){
                    // console.log("el rol es admin")
                      
                      localStorage.setItem('currentRole', JSON.stringify({admin: true}));
                      this.currentRoleSubject.next({admin: true});
                  }else{
                    // console.log("el log es otra cosa")
                      this.currentRoleSubject.next({admin: false});
                      localStorage.setItem('currentRole', JSON.stringify({admin: false}));
                  }
                  
                  // console.log("vamos con el rol")
                  // console.log(this.currentRole)
                  // console.log(this.currentUser)
                }else{
                  // remove user from local storage and set current user to null
                  localStorage.removeItem('currentUser');
                  localStorage.removeItem('currentRole');
                  this.currentUserSubject.next(null);
                  this.currentRoleSubject.next(null);
                }
                return user;
            }));
    }

    loginByToken(token){
      this.url_final = this.backendUrl + "/login_token"
        return this.http.post<any>(this.url_final, { token })
            .pipe(map(user => {
                if(user.result == 200){
                  // store user details and jwt token in local storage to keep user logged in between page refreshes
                  localStorage.setItem('currentUser', JSON.stringify(user));
                  this.currentUserSubject.next(user);
                  // console.log("la respuesta es")
                  // console.log(user.result);

                  if(user["role"] == "admin"){
                    // console.log("el rol es admin")
                      
                      localStorage.setItem('currentRole', JSON.stringify({admin: true}));
                      this.currentRoleSubject.next({admin: true});
                  }else{
                    // console.log("el log es otra cosa")
                      this.currentRoleSubject.next({admin: false});
                      localStorage.setItem('currentRole', JSON.stringify({admin: false}));
                  }
                  
                  // console.log("vamos con el rol")
                  // console.log(this.currentRole)
                  // console.log(this.currentUser)
                }else{
                  // remove user from local storage and set current user to null
                  localStorage.removeItem('currentUser');
                  localStorage.removeItem('currentRole');
                  this.currentUserSubject.next(null);
                  this.currentRoleSubject.next(null);
                }
                return user;
            }));
    }

    restaurarPassword(username) {
      this.url_final = this.backendUrl + "/restaurar_password"
      return this.http.post<any>(this.url_final, { username })
      .pipe(map(response => {
        return response;
      }));
    }

    cambiarPassword(token, password) {
      // console.log("Los valores a enviar son "+token);
      // console.log("Los valores a enviar son "+password);
      this.url_final = this.backendUrl + "/cambiar_password"
      return this.http.post<any>(this.url_final, { token, password })
      .pipe(map(response => {
        return response;
      }));
    }

    cambiarCorreo(email) {
      // console.log("Los valores a enviar son " + email);
      this.url_final = this.backendUrl + "/rmsfe/cambiar_correo"
      return this.http.post<any>(this.url_final, { email })
      .pipe(map(response => {
        return response;
      }));
    }

    cambiarAlias(seller_alias) {
      // console.log("Los valores a enviar son " + seller_alias);
      this.url_final = this.backendUrl + "/rmsfe/cambiar_alias_seller"
      


      return this.http.post<any>(this.url_final, { seller_alias })
      .pipe(map(response => {
        
        return response;
      }));
    }

    cambiarContacto(persona_contacto, correo_contacto, telefono) {
      // console.log("Los valores a enviar son " + persona_contacto);
      this.url_final = this.backendUrl + "/rmsfe/actualizar_contacto_seller"
      return this.http.post<any>(this.url_final, { persona_contacto, correo_contacto, telefono })
      .pipe(map(response => {
        return response;
      }));
    }

    cambiarPasswordLogeado(old_password, nuevo_password) {
      // console.log("Los valores a enviar son password" );
      const headers = {"nuevo_password": nuevo_password, "old_password": old_password}
      this.url_final = this.backendUrl + "/rmsfe/cambiar_password_logeado"
      return this.http.post<any>(this.url_final, { }, {headers})
      .pipe(map(response => {
        return response;
      }));
    }

    actualizarEntrada(entrada_token, num_guia, paqueteria) {
      this.url_final = this.backendUrl + "/rmsfe/guardar_guia_entrada"
      this.url_final =
        `${this.url_final}?entrada_token=${entrada_token}&paqueteria=${paqueteria}&num_guia=${num_guia}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarFolioRestauracion(token){
      this.url_final = this.backendUrl + "/consultar_folio_restauracion"
      return this.http.post<any>(this.url_final, { token })
      .pipe(map(response => {
        // console.log("la response de rms fue");
        // console.log(response);
        return response;
      }));
    }

    consultarUser(){
      // console.log("vamos con consultarUser");
      // console.log(this.backendUrl);
      this.url_final = this.backendUrl + "/rmsfe/consultar_user";
      return this.http.post<any>(this.url_final,  {})
         .pipe(map(user => {
      
        if(user.result == 200){
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(user));
            this.currentUserSubject.next(user);
            // console.log("la respuesta es")
            // console.log(user.result);

            if(user["role"] == "admin"){
              // console.log("el rol es admin")
                
                localStorage.setItem('currentRole', JSON.stringify({admin: true}));
                this.currentRoleSubject.next({admin: true});
            }else{
              // console.log("el log es otra cosa")
                this.currentRoleSubject.next({admin: false});
                localStorage.setItem('currentRole', JSON.stringify({admin: false}));
            }
            
            // console.log("vamos con el rol")
            // console.log(this.currentRole)
            // console.log(this.currentUser)
          }else{
            // remove user from local storage and set current user to null
            localStorage.removeItem('currentUser');
            localStorage.removeItem('currentRole');
            this.currentUserSubject.next(null);
            this.currentRoleSubject.next(null);
          }
          return user;

      }));
      // console.log("terminamos consultar user");
    }



    logout() {
        // remove user from local storage and set current user to null
        localStorage.removeItem('currentUser');
        localStorage.removeItem('currentRole');
        this.currentUserSubject.next(null);
        this.currentRoleSubject.next(null);
    }
    //!FUNCION QUE VALIDA LOS PERMISOS
    validar_roles(clave_modulo,modulos){  
      let contador = 0;
      modulos.forEach(element => { 
        if(clave_modulo == element.clave){
          contador++;
        }
      }); 
      if(contador >0){
        return true;
      }else{
        return false;
      }  
    }

    cambiarRFC(rfc) {
      this.url_final = this.backendUrl + "/rmsfe/actualizar_rfc_seller"
      return this.http.post<any>(this.url_final, { rfc })
      .pipe(map(response => {
        return response;
      }));
    }

    obtenerMetabaseDashboardUrl(): Observable<any> {
      this.url_final = this.backendUrl + "/rmsfe/metabase_dashboard_url";
      return this.http.get<any>(this.url_final, { observe: 'response' })
      .pipe(map(response => {
        return response;
      }));
    }
}